<template>
  <view
    class="custom-tabbar"
    :style="{
      height: tabBarTotalHeight + 'px',
      paddingBottom: safeAreaBottom + 'px'
    }"
  >
    <view class="tabbar-content">
      <view
        class="tabbar-item"
        :class="{ 'tabbar-item--active': resolvedActiveIndex === index }"
        v-for="(item, index) in visibleTabs"
        :key="item.pagePath"
        @click="switchTab(item, index)"
      >
        <view v-if="resolvedActiveIndex === index" class="tabbar-active-line" aria-hidden="true" />
        <view class="icon-placeholder" :class="{ active: resolvedActiveIndex === index }">
          <view class="icon-wrapper">
            <image
              :src="resolvedActiveIndex === index ? item.selectedIconPath : item.iconPath"
              class="tabbar-icon"
              mode="aspectFit"
            ></image>
          </view>
        </view>
      </view>
    </view>
  </view>
</template>

<script>
import { loadFeatureFlags, getCachedFeatureFlags } from '@/utils/feature-flags'

const ALL_TABS = [
  {
    pagePath: 'pages/home/home',
    iconPath: '/static/images/tabbar/home.png',
    selectedIconPath: '/static/images/tabbar/home-active.png',
    text: '主页'
  },
  {
    pagePath: 'pages/market/market',
    iconPath: '/static/images/tabbar/market.png',
    selectedIconPath: '/static/images/tabbar/market-active.png',
    text: '市集',
    feature: 'marketEnabled'
  },
  {
    pagePath: 'pages/store/store',
    iconPath: '/static/images/tabbar/user.png',
    selectedIconPath: '/static/images/tabbar/user-active.png',
    text: '商城'
  },
  {
    pagePath: 'pages/my/my',
    iconPath: '/static/images/tabbar/shop.png',
    selectedIconPath: '/static/images/tabbar/shop-active.png',
    text: '我的'
  }
]

export default {
  name: 'custom-tabbar',
  props: {
    currentPagePath: {
      type: String,
      default: ''
    }
  },
  data() {
    const cached = getCachedFeatureFlags()
    return {
      ALL_TABS,
      marketEnabled: !!cached.marketEnabled,
      safeAreaBottom: 0,
      tabBarBaseHeight: 56,
      tabBarTotalHeight: 56
    }
  },
  computed: {
    visibleTabs() {
      return this.ALL_TABS.filter((t) => {
        if (t.feature === 'marketEnabled') return this.marketEnabled
        return true
      })
    },
    normalizedPath() {
      return (this.currentPagePath || '').replace(/^\//, '') || this.visibleTabs[0]?.pagePath || ALL_TABS[0].pagePath
    },
    resolvedActiveIndex() {
      const i = this.visibleTabs.findIndex((t) => t.pagePath === this.normalizedPath)
      return i >= 0 ? i : 0
    }
  },
  mounted() {
    this.calcTabBarHeight()
    this.refreshFlags()
  },
  methods: {
    async refreshFlags() {
      try {
        const f = await loadFeatureFlags(true)
        this.marketEnabled = !!f.marketEnabled
      } catch (e) {
        this.marketEnabled = false
      }
    },
    calcTabBarHeight() {
      try {
        const systemInfo = uni.getSystemInfoSync()
        const bottom = Number(systemInfo.safeAreaInsets?.bottom) || 0
        this.safeAreaBottom = bottom
        this.tabBarTotalHeight = this.tabBarBaseHeight + bottom
      } catch (e) {
        this.tabBarTotalHeight = this.tabBarBaseHeight
        this.safeAreaBottom = 0
      }
    },
    switchTab(item) {
      if (item.feature === 'marketEnabled' && !this.marketEnabled) return
      if (item.pagePath === this.normalizedPath) return
      const targetPath = item.pagePath.replace(/^\//, '')
      try {
        uni.reLaunch({
          url: `/${targetPath}`,
          fail: () => {
            if (typeof window !== 'undefined') {
              const fullPath = process.env.NODE_ENV === 'development'
                ? `/#/${targetPath}`
                : `/${targetPath}.html`
              window.history.pushState({}, '', fullPath)
              window.location.reload()
            }
          }
        })
      } catch (e) {
        uni.showToast({ title: '切换失败', icon: 'none' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.custom-tabbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: $tabbar-bg;
  display: flex;
  flex-direction: column;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  z-index: 9999;
  box-sizing: border-box;
  overflow: visible;
}

.tabbar-content {
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  padding: 8rpx 0 6rpx;
  min-height: 0;
  box-sizing: border-box;
  overflow: visible;
}

.tabbar-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 0;
  position: relative;
  overflow: visible;
}

/* 选中项顶部细线 */
.tabbar-active-line {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 56rpx;
  height: 4rpx;
  border-radius: 2rpx;
  background: #00ff88;
  pointer-events: none;
  z-index: 1;
}

.tabbar-item--active .icon-placeholder {
  position: relative;
  z-index: 1;
}

.icon-placeholder {
  width: 64rpx;
  height: 64rpx;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0;
  transition: all 0.2s ease;
  border-radius: 50%;
  flex-shrink: 0;
}

.icon-placeholder {
  transform: translateY(28rpx);
}

.icon-wrapper {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tabbar-icon {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
}
</style>
